var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05259 15C6.05259 14.4477 6.49638 14 7.04382 14H16.9561C17.5036 14 17.9474 14.4477 17.9474 15V16H21.702C21.967 16 22.0996 16.3231 21.9123 16.5121L20.6478 17.7879C20.5316 17.905 20.5316 18.095 20.6478 18.2121L21.9123 19.4879C22.0996 19.6769 21.967 20 21.702 20H18.9386C18.3912 20 17.9474 19.5523 17.9474 19V18.3C17.9474 18.1343 17.8142 18 17.65 18H6.34996C6.18573 18 6.05259 18.1343 6.05259 18.3V19C6.05259 19.5523 5.6088 20 5.06136 20H2.29797C2.03304 20 1.90036 19.6769 2.08769 19.4879L3.35224 18.2121C3.46837 18.095 3.46837 17.905 3.35224 17.7879L2.08769 16.5121C1.90036 16.3231 2.03304 16 2.29797 16H6.05259V15Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83462 5.36707C4.37811 5.52414 4.07019 5.96513 4.07019 6.46184V9.61346C4.07019 11.1029 4.33402 12.5468 4.8238 13.8881C5.22945 13.0653 6.07122 12.5 7.04388 12.5H16.9561C17.9288 12.5 18.7706 13.0653 19.1762 13.8881C19.666 12.5468 19.9298 11.1029 19.9298 9.61346V6.46184C19.9298 5.96513 19.6219 5.52414 19.1654 5.36707L12.5572 3.09334C12.1955 2.96889 11.8045 2.96889 11.4427 3.09334L4.83462 5.36707Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01471 19.5H14.9853C14.2083 20.0696 13.3561 20.5471 12.4404 20.9147C12.1571 21.0284 11.8428 21.0284 11.5595 20.9147C10.6439 20.5471 9.79164 20.0696 9.01471 19.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge10);
export default __webpack_public_path__ + "static/media/badge-10.b1949e763eb7fa3b1d54f266b28063f8.svg";
export { ForwardRef as ReactComponent };